import { z } from "zod";

export const UploadPurposeValues = [
  "ACCEPTED_DRIVER_DOCUMENT_UPLOAD",
  "DRIVER_DOCUMENT_RENEWAL_UPLOAD",
  "DRIVER_DOCUMENT_INITIAL_UPLOAD",
] as const;

export const UploadPurposeSchema = z.enum(UploadPurposeValues);

export type UploadPurpose = z.infer<typeof UploadPurposeSchema>;

export const UPLOAD_PURPOSES: Record<UploadPurpose, UploadPurpose> = {
  ACCEPTED_DRIVER_DOCUMENT_UPLOAD: "ACCEPTED_DRIVER_DOCUMENT_UPLOAD",
  DRIVER_DOCUMENT_RENEWAL_UPLOAD: "DRIVER_DOCUMENT_RENEWAL_UPLOAD",
  DRIVER_DOCUMENT_INITIAL_UPLOAD: "DRIVER_DOCUMENT_INITIAL_UPLOAD",
};
